










import { PROTOCAOL_LIST } from '@/common/biz/constants'
import { computed, defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
  props: {
    contentType: {
      type: String as PropType<'1'|'2'|'3'>,
      default: '1'
    }
  },
  setup(props) {
    const list = computed(() => {
      if (props.contentType === '1') {
        return [{
          name: '《个人信息授权书》',
          type: '1'
        }, {
          name: '《委托付款授权确认书》',
          type: '2'
        }]
      } else if (props.contentType === '2') {
        return [{
          name: '《个人信息授权书》',
          type: '3'
        }]
      } else {
        return [{
          name: '补贴：《个人信息授权书》',
          type: '1'
        }, {
          name: '补贴：《委托付款授权确认书》',
          type: '2'
        }, {
          name: '自费：《个人信息授权书》',
          type: '3'
        }]
      }
    })

    const linkToPage = (type) => {
      window.location.href = PROTOCAOL_LIST[type]
    }
    return {
      list,
      linkToPage
    }
  }
})
